import { Controller } from 'stimulus';
import {
  myTemplatesListHasMorePages,
  resetMyTemplatesList,
} from '../add_to_my_templates_controller';

export default class extends Controller {
  static values = { collectionId: Number, resetUrl: String };

  async sync({ detail: { name } }) {
    this.#updateSlide(name);

    // The list is paginated by name, so a moved name shifts the pages not loaded yet.
    if (!myTemplatesListHasMorePages()) {
      return;
    }

    const cardId = this.element.id;
    if (await resetMyTemplatesList(this.resetUrlValue)) {
      this.#restoreFocus(cardId);
    }
  }

  // The reset removed the focused card. Focus its replacement, or the My Templates tab when the new
  // name sorts past the first page, unless the user has moved focus elsewhere in the meantime.
  #restoreFocus(cardId) {
    if (document.activeElement && document.activeElement !== document.body) {
      return;
    }

    const card = document.getElementById(cardId);
    const target =
      card?.querySelector('.moodboard--templates--thumb-trigger') ??
      document.querySelector('[data-moodboard--navigation-target="item"][value="private"]');
    target?.focus();
  }

  // The slide header and its template forms are rendered once, so they need the new name too.
  #updateSlide(name) {
    const slide = document.getElementById(
      `slide_board_template_collection_${this.collectionIdValue}`
    );
    const pendingSlide = this.element.querySelector(
      'template[data-controller="moodboard--mover"]'
    )?.content;

    for (const root of [slide, pendingSlide]) {
      root
        ?.querySelectorAll(`[data-collection-title="${this.collectionIdValue}"]`)
        .forEach((title) => {
          title.textContent = name;
        });
      root?.querySelectorAll('[data-collection-name]').forEach((template) => {
        template.dataset.collectionName = name;
      });
    }
  }
}
